import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {isInt} from 'validator';
import {GreatForm} from 'components/common';
import {InputField, SelectField, ImageField} from 'components/common/rc-fields';
import {createCommonImage, updateCommonImage} from 'api/images';
import {levelMap, levelOptions, isNullOrUndefined} from 'utils/common';

const CommonImageForm = ({form, initialValues, onCancel, onSubmitSuccess, type}) => {
  const isUpdate = !isEmpty(initialValues);
  const {versionCode, level, order, image} = initialValues || {};

  return (
    <GreatForm
      form={form}
      onCancel={onCancel}
      submitFn={
        isUpdate
          ? (payload) => updateCommonImage({id: initialValues.id, ...payload})
          : (payload) => createCommonImage({type, ...payload})
      }
      onSuccess={onSubmitSuccess}
      successMsg={`Image has been ${isUpdate ? 'updated' : 'created'} successfully`}
    >
      <Grid container spacing={2}>
        {!isUpdate && (
          <React.Fragment>
            <Grid item xs={12}>
              <InputField
                name="versionCode"
                label="Version Code"
                initialValue={versionCode || ''}
                rules={[{required: true, message: 'Please enter Version Code'}]}
                form={form}
              />
            </Grid>
            <Grid item xs={12}>
              <SelectField
                name="level"
                label="Level"
                initialValue={level || ''}
                options={levelOptions}
                rules={[{required: true, message: 'Please select level'}]}
                form={form}
                autoComplete="off"
                renderValue={(value) => levelMap[value]}
              />
            </Grid>
          </React.Fragment>
        )}
        <Grid item xs={12}>
          <InputField
            name="order"
            label="Order"
            initialValue={!isNullOrUndefined(order) ? order.toString() : ''}
            rules={[
              {required: true, message: 'Please enter Order'},
              {
                validator(rule, value, callback) {
                  const errors = [];
                  if (value && !isInt(value, {min: 0})) {
                    errors.push('Please enter a valid order');
                  }
                  callback(errors);
                },
              },
            ]}
            form={form}
            type="number"
          />
        </Grid>
        <Grid item xs={12}>
          <ImageField
            name="image"
            label="Image"
            initialValue={isNullOrUndefined(image) ? undefined : image}
            rules={[{required: true, message: 'Please select an image'}]}
            form={form}
          />
        </Grid>
      </Grid>
    </GreatForm>
  );
};

CommonImageForm.propTypes = {
  form: formShape.isRequired,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func,
  onSubmitSuccess: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

CommonImageForm.defaultProps = {
  initialValues: {},
};

export default createForm()(CommonImageForm);
